import * as React from "react"
const DownIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={ 31 }
        height={ 24 }
        fill="none"
        { ...props }
    >
        <path
            fill="#ED0303"
            d="m30.744 22.232-.598-7.217c-.07-.792-.844-1.133-1.29-.575l-1.412 1.77L18.55 5.062c-.558-.7-1.541-.7-2.099 0l-4.899 6.14L3.275.822C2.988.465 2.608.279 2.228.279c-.38 0-.761.186-1.047.544-.278.35-.433.822-.433 1.316 0 .493.155.966.433 1.315l9.324 11.686c.558.7 1.541.7 2.094 0l4.904-6.14 7.848 9.835-1.655 2.074c-.45.563-.178 1.534.455 1.615l5.758.75c.112.015.225-.001.332-.048a.755.755 0 0 0 .284-.222c.08-.1.14-.221.179-.354.038-.134.052-.276.04-.417Z"
        />
    </svg>
)
export default DownIcon